import { render, staticRenderFns } from "./ReportFieldFontSelect.vue?vue&type=template&id=0d936802"
import script from "./ReportFieldFontSelect.vue?vue&type=script&lang=js"
export * from "./ReportFieldFontSelect.vue?vue&type=script&lang=js"
import style0 from "./ReportFieldFontSelect.vue?vue&type=style&index=0&id=0d936802&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports